<script>
import GoogleMaps from "@/components/_Shared/GoogleMaps";
import DetailButton from "@/components/_Shared/Orders/Show/DetailButton";
import CancelOrder from "@/components/Orders/ShowOrder/CancelOrder";
import ConfirmPayment from "@/components/Orders/ShowOrder/ConfirmPayment";
import GoogleForms from "@/utils/googleForms.js";
import SetServiceNotProvided from "@/components/Orders/ShowOrder/SetServiceNotProvided";
import RestoreOrderToPaid from "@/components/Orders/ShowOrder/RestoreOrderToPaid";
import UpdateDescription from "@/components/Orders/ShowOrder/UpdateDescription";

import dateMixin from "@/mixins/dateMixin";
import orderMixin from "@/mixins/orderMixin";
import objectMixin from "@/mixins/objectMixin";
import numbertMixin from "@/mixins/numberMixin";

const getValueOf = (obj, chain, def) => {
  return objectMixin.methods.get(obj, chain, def);
};

const formatDate = (date, format = "DD/MM/YYYY HH:mm") => {
  return dateMixin.filters.formatDate(date, format);
};

export default {
  title: "Detalhe do pedido",

  mixins: [dateMixin, orderMixin, objectMixin],

  components: {
    GoogleMaps,
    DetailButton,
    CancelOrder,
    ConfirmPayment,
    SetServiceNotProvided,
    UpdateDescription,
    RestoreOrderToPaid
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      lat: null,
      lng: null,
      showMap: false,
      updatedescription: false
    };
  },

  methods: {
    getLatLng() {
      let arr = getValueOf(this.order, "address.lonlat").split(" ");
      this.lng = parseFloat(arr[1].substr(1));
      this.lat = parseFloat(arr[2].substr(0, arr[2].length - 1));
    },
    getPhone(accountable_str) {
      let phones = getValueOf(this.order, `${accountable_str}.account.phones`);
      if (phones) {
        return phones.length > 0
          ? `(${phones[0].area_code}) ${phones[0].number}`
          : "";
      }
      return "";
    },
    getCustomerDocument() {
      let customer = getValueOf(this.order, "customer");
      return customer.cpf || customer.cnpj;
    },
    customerRoute() {
      return this.order.customer.type === "physicals"
        ? "clients-b2c-edit"
        : "clients-b2b-edit";
    },
    createInfringementFormlink() {
      return GoogleForms.buildGoogleFormsURL("delayForm", this.order);
    },
    createCSInfringementFormlink() {
      return GoogleForms.buildGoogleFormsURL("infringementForm", this.order);
    }
  },

  watch: {
    "order.address.lonlat": function() {
      let arr = getValueOf(this.order, "address.lonlat").split(" ");
      this.lng = parseFloat(arr[1].substr(1));
      this.lat = parseFloat(arr[2].substr(0, arr[2].length - 1));
    }
  },

  computed: {
    canConfirmPayment() {
      return (
        this.order.status === "waiting_payment" ||
        this.order.status === "payment_requested"
      );
    },
    wirecardUrl() {
      return `https://conta.wirecard.com.br/orders/${this.get(
        this.order,
        "payment_gateway_id"
      )}`;
    }
  },

  mounted() {
    this.getLatLng();
  }
};
</script>

<template>
  <v-container fluid>
    <v-layout row class="title-form">CLIENTE</v-layout>
    <v-layout row fill-height wrap>
      <v-flex md3 xs12>
        <p>
          <strong>Nome:</strong>

          <router-link
            :to="{
              name: customerRoute(),
              params: { id: order.customer.account.id }
            }"
          >
            <b>
              {{ get(this.order, "customer.account.first_name") }}
              {{ get(this.order, "customer.account.last_name") }}
            </b>
          </router-link>
        </p>

        <p v-if="this.order.customer.type === 'legals'">
          <strong>Razão Social:</strong>
          {{ get(this.order, "customer.business_name") }}
        </p>
      </v-flex>

      <v-flex md3 xs12>
        <p>
          <strong>Email:</strong>
          {{ get(this.order, "customer.account.email") }}
        </p>

        <p v-if="this.order.customer.type === 'legals'">
          <strong>Nome Fantasia:</strong>
          {{ get(this.order, "customer.company_name") }}
        </p>
      </v-flex>

      <v-flex md3 xs12>
        <p>
          <strong>Telefone:</strong>
          {{ getPhone("customer") }}
        </p>
      </v-flex>

      <v-flex md3 xs12>
        <p>
          <strong>CPF/CNPJ:</strong>
          {{ getCustomerDocument() }}
        </p>
      </v-flex>
    </v-layout>

    <v-layout row class="title-form">PROFISSIONAL</v-layout>
    <v-layout row fill-height wrap>
      <v-flex md3 xs12>
        <p>
          <strong>Nome:</strong>
          <router-link
            :to="`/profissionais/${get(this.order, 'professional.id')}`"
          >
            <b>
              {{ get(this.order, "professional.account.first_name") }}
              {{ get(this.order, "professional.account.last_name") }}
            </b>
          </router-link>
        </p>
      </v-flex>

      <v-flex md3 xs12>
        <p>
          <strong>Email:</strong>
          {{ get(this.order, "professional.account.email") }}
        </p>
      </v-flex>

      <v-flex md2 xs12>
        <p>
          <strong>Telefone:</strong>
          {{ getPhone("professional") }}
        </p>
      </v-flex>

      <v-flex md2 xs12>
        <p>
          <a class="contrast" :href="createInfringementFormlink()"
            >Avisar Atraso</a
          >
        </p>
      </v-flex>

      <v-flex md2 xs12>
        <p>
          <a class="contrast" :href="createCSInfringementFormlink()"
            >Infração</a
          >
        </p>
      </v-flex>
    </v-layout>

    <v-layout row class="title-form">LOCAL</v-layout>
    <!-- STREET, ZIPCODE, NUMBER AND COMPLEMENT -->
    <v-layout align-center justify-space-between row fill-height wrap>
      <v-flex md3 xs12>
        <p>
          <strong>Rua:</strong>
          {{ get(this.order, "address.street") }}
        </p>
      </v-flex>
      <v-flex md3 xs7>
        <p>
          <strong>CEP:</strong>
          {{ get(this.order, "address.zip_code") }}
        </p>
      </v-flex>
      <v-flex md3 xs5>
        <p>
          <strong>Número:</strong>
          {{ get(this.order, "address.street_number") }}
        </p>
      </v-flex>
      <v-flex md3 xs12>
        <p>
          <strong>Complemento:</strong>
          {{ get(this.order, "address.complement") }}
        </p>
      </v-flex>
    </v-layout>
    <!-- DISTRICT, CITY, STATE AND COUNTRY  -->
    <v-layout align-center justify-space-between row fill-height wrap>
      <v-flex md3 xs12>
        <p>
          <strong>Bairro:</strong>
          {{ get(this.order, "address.district.display_name") }}
        </p>
      </v-flex>
      <v-flex md3 xs7>
        <p>
          <strong>Cidade:</strong>
          {{ get(this.order, "address.district.city.display_name") }}
        </p>
      </v-flex>
      <v-flex md3 xs5>
        <p>
          <strong>Estado:</strong>
          {{ get(this.order, "address.district.city.state.code") }}
        </p>
      </v-flex>
      <v-flex md3 xs12>
        <p>
          <strong>País:</strong>
          {{
            get(this.order, "address.district.city.state.country.display_name")
          }}
        </p>
      </v-flex>
    </v-layout>
    <!-- REFERENCE -->
    <v-layout align-center justify-space-between row fill-height wrap>
      <v-flex xs12>
        <p>
          <strong>Referência de localização:</strong>
          {{ get(this.order, "address.reference") }}
        </p>
      </v-flex>
    </v-layout>
    <!-- GEOLOCATION -->
    <v-layout align-center justify-space-between row fill-height wrap>
      <v-flex xs12>
        <p>
          <strong>Geolocalização:</strong>
          <v-btn small outlined color="primary" @click="showMap = true"
            >mostrar no mapa</v-btn
          >
          <google-maps
            v-if="lat && lng && showMap"
            name="geolocation"
            :lat="lat"
            :lng="lng"
            :withAutocomplete="false"
          />
        </p>
      </v-flex>
    </v-layout>
    <!-- DAY, DURATION, START AND PROFESSIONAL  -->
    <v-layout align-center justify-space-between row fill-height wrap>
      <v-flex md3 xs12 column>
        <v-flex>
          <v-layout row class="title-form">DIA</v-layout>
        </v-flex>
        <v-flex>
          <p>
            {{
              get(this.order, "schedule_event.starts_at")
                | formatDate("dddd, D/M/YYYY")
            }}
          </p>
        </v-flex>
      </v-flex>
      <v-flex md3 xs12 column>
        <v-flex xs12>
          <v-layout row class="title-form">DURAÇÃO</v-layout>
        </v-flex>
        <v-flex xs12>
          <p>
            {{ get(this.order, "schedule_event.duration") | durationInHous }}
          </p>
        </v-flex>
      </v-flex>
      <v-flex md3 xs12 column>
        <v-flex xs12>
          <v-layout row class="title-form">INÍCIO</v-layout>
        </v-flex>
        <v-flex xs12>
          <p>
            {{
              get(this.order, "schedule_event.starts_at") | formatDate("HH:mm")
            }}
          </p>
        </v-flex>
      </v-flex>
      <v-flex md3 xs12 column>
        <v-flex>
          <v-layout row class="title-form">STATUS</v-layout>
        </v-flex>
        <v-flex>
          <p>{{ get(this.order, "status") | getStatusName() }}</p>
        </v-flex>
      </v-flex>
    </v-layout>
    <!-- CREATED_AT and WIRECARD_ID -->
    <v-layout align-center justify-space-between row fill-height wrap>
      <v-flex md3 xs12 column>
        <v-flex>
          <v-layout row class="title-form">CRIAÇÃO</v-layout>
        </v-flex>
        <v-flex>
          <p>
            {{
              get(this.order, "created_at") | formatDate("dddd, D/M/YYYY HH:mm")
            }}
          </p>
        </v-flex>
      </v-flex>
      <v-flex md3 xs12 column>
        <v-flex xs12>
          <v-layout row class="title-form">WIRECARD ID</v-layout>
        </v-flex>
        <v-flex xs12>
          <a class="contrast" :href="wirecardUrl" target="_blank">
            <p>{{ get(this.order, "payment_gateway_id") }}</p>
          </a>
        </v-flex>
      </v-flex>
      <v-flex md3 xs12 column></v-flex>
      <v-flex md3 xs12 column></v-flex>
    </v-layout>
    <!-- DESCRIPTION -->
    <v-layout align-start row>
      <v-layout align-center justify-start row fill-heigh>
        <v-flex>
          <span class="title-form">DESCRIÇÃO</span>
          <v-btn
            small
            outlined
            color="primary"
            @click="updatedescription = !updatedescription"
            >editar</v-btn
          >
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout align-center justify-space-between row fill-height wrap>
      <p>{{ get(this.order, "description") }}</p>
    </v-layout>

    <!-- ACTIONS -->
    <v-layout align-center justify-space-between row fill-height wrap>
      <!-- <v-flex>
        <DetailButton :disabled="true" imageSrc="/static/nf.svg" title="SOLICITAR NOTA FISCAL" />
      </v-flex>-->

      <v-flex>
        <DetailButton
          v-if="get(this.order, 'status') === 'cancelled'"
          :disabled="true"
          :outline="false"
          imageSrc="/static/cancel.svg"
          title="PEDIDO CANCELADO"
        />
        <CancelOrder v-else :order="this.order" @refresh="$emit('refresh')" />
      </v-flex>

      <!-- <v-flex>
        <DetailButton :disabled="true" imageSrc="/static/extra-hours.svg" title="HORA ADICIONAL" />
      </v-flex>-->

      <v-flex>
        <DetailButton
          :disabled="!canReschedule(order.status)"
          :outline="canReschedule(order.status)"
          @clicked="
            $router.push({ name: 'rebooking', params: { id: order.id } })
          "
          imageSrc="/static/reschedule.svg"
          title="REAGENDAR"
        />
      </v-flex>

      <v-flex v-if="canConfirmPayment">
        <ConfirmPayment :order="this.order" @refresh="$emit('refresh')" />
      </v-flex>

      <v-flex v-if="canSetServiceNotProvided(order.status)">
        <SetServiceNotProvided
          :order="this.order"
          @refresh="$emit('refresh')"
        />
      </v-flex>

      <v-flex v-if="canRestoreToPaid(order.status)">
        <RestoreOrderToPaid :order="this.order" @refresh="$emit('refresh')" />
      </v-flex>
    </v-layout>

    <UpdateDescription
      v-if="updatedescription"
      @close="updatedescription = false"
      @refresh="$emit('refresh')"
      :order="this.order"
    />
  </v-container>
</template>

<style scoped>
.contrast {
  font-weight: 500;
  font-size: 14px;
  color: var(--purple);
}
</style>



// WEBPACK FOOTER //
// src/components/Orders/ShowOrder/OrderDetails.vue